import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";
import {ForYouEventType} from "../types/ForYouEventType";

export const ForYouBannerGtmEvent = (region: string) => {
    const data = {
        event: ForYouEventType.BANNER,
        event_action: "click",
        event_category: region
    };

    hitGoogleTagManager(data);
};
